import { useState } from 'react'
import { PlusIcon } from '@heroicons/react/outline'
import { useEditClient } from 'modules/Clients/hooks/useEditClient'
import { CreateUser } from './CreateUser'

export function AddUserButton() {
  const { isLoadingUsers, enterprise, client } = useEditClient()
  const [isCreateOpen, setIsCreateOpen] = useState(false)

  const isEnterpriseCreated =
    client?.relationships?.enterprise?.id && enterprise

  if (isLoadingUsers || !isEnterpriseCreated) return null

  return (
    <>
      <button
        type="button"
        onClick={() => setIsCreateOpen(true)}
        className="h-9 flex items-center justify-center text-sm font-medium rounded-md text-emerald-600 border border-emerald-600 hover:bg-emerald-600 hover:text-white"
      >
        <div className="flex flex-row items-center justify-center px-3">
          <PlusIcon className="h-5 w-5" aria-hidden="true" />
          <span className="ml-1">Adicionar administrador</span>
        </div>
      </button>
      <CreateUser open={isCreateOpen} setOpen={setIsCreateOpen} />
    </>
  )
}
